const getStatusColor = (status: string) => {
  if (status === 'success') return 'success';
  if (status === 'error-409') return 'warning';
  return 'error';
};
export default getStatusColor;
